import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import Auth0Provider from "./components/Auth/Auth0Provider.jsx";
import BreadcrumbsProvider from "./components/Breadcrumbs/BreadcrumbsProvider.jsx";
import App from "./App.jsx";
import "./index.css";
import { Toaster } from "react-hot-toast";
import ErrorBoundary from "./components/Error/ErrorBoundary.jsx";
import { init as initApm } from "@elastic/apm-rum";
import log from "./util/log";

if (["local", "dev", "development", "test"].includes(ENV) === false) {
	const apm = initApm({
		serviceName: "warrisk-portal-ui",
		serviceVersion: SOURCE_VERSION || "unknown",
		serverUrl:
			import.meta.env.VITE_ELASTIC_APM_SERVER_URL ||
			"https://warrisk.apm.northeurope.azure.elastic-cloud.com:443",
		environment: ENV,
	});
	log.init(apm);
} else {
	console.warn("Elastic APM is disabled in development & test environment");
}

createRoot(document.getElementById("root")).render(
	<StrictMode>
		<BrowserRouter>
			<ErrorBoundary>
				<Auth0Provider domain={AUTH0_DOMAIN} clientId={AUTH0_CLIENTID}>
					<BreadcrumbsProvider>
						<App />
					</BreadcrumbsProvider>
				</Auth0Provider>
			</ErrorBoundary>
		</BrowserRouter>
		<Toaster position="top-right" />
	</StrictMode>
);
